/**
 * @description
 */

import './sectionResultList.scss';

import React, { Component } from 'react';
import { components } from 'common';
const { Loading } = components;
import { getPollResultStat } from '@umu/umu-api';
import { ISurveySectionInfo } from '@umu/umu-types';

import SectionResultItem from './@sectionResultItem/sectionResultItem';
import { combineSectionListWithStatResult, transformSectionList } from '../../services/@pollService/pollService';

import { PollType } from '@umu/umu-types';

export interface IProps {
    sectionList: ISurveySectionInfo[];
    parentId: number;
    objId: number;
    questionIds?: string;
}

export interface IState {
    sectionList?: ISurveySectionInfo[];
    sectionListWithStatResult: ISurveySectionInfo[];
}

export default class SectionResultList extends Component<IProps, IState> {
    public static getDerivedStateFromProps(nextProps: IProps, _prevState: IState) {
        const sectionList = transformSectionList(nextProps.sectionList);
        return {
            sectionList,
        };
    }

    public sectionListWithStatResult: ISurveySectionInfo[] = [];

    constructor(props: IProps, state: IState) {
        super(props, state);

        this.state = {
            sectionListWithStatResult: [],
        };
    }

    public getStatResult = () => {
        const { sectionList } = this.state;
        if (!sectionList) {
            return;
        }

        const { parentId, objId, questionIds } = this.props;
        getPollResultStat(
            Object.assign(
                {
                    parent_id: parentId,
                    parent_type: PollType.HOMEWORK_EVAL_POLL,
                    obj_id: objId,
                },
                questionIds
                    ? {
                          question_ids: questionIds,
                      }
                    : {},
            ),
        ).then((ret) => {
            if (ret.error_code) {
                return;
            }
            this.setState({
                sectionListWithStatResult: combineSectionListWithStatResult(sectionList, ret.data),
            });
        });
    };

    public componentDidMount() {
        this.getStatResult();
    }

    public componentDidUpdate(_prevProps: IProps, prevState: IState) {
        if (JSON.stringify(this.state.sectionList) !== JSON.stringify(prevState.sectionList)) {
            this.getStatResult();
        }
    }

    public renderSectionResults() {
        const { parentId, objId } = this.props;
        return (
            <div className="section-result-list">
                {this.state.sectionListWithStatResult.map((sectionInfo: ISurveySectionInfo) => {
                    return (
                        <SectionResultItem
                            key={sectionInfo.id}
                            sectionInfo={sectionInfo}
                            parentId={parentId}
                            objId={objId}
                        ></SectionResultItem>
                    );
                })}
            </div>
        );
    }

    public render() {
        if (this.state.sectionListWithStatResult.length === 0) {
            return <Loading />;
        }
        return this.renderSectionResults();
    }
}
